import React from 'react';
import { Alert, Button } from 'reactstrap';
import { Timeline } from '../../../slices/marketplace/timeline/models/timeline.model';
import { stepsWaitingForTheSellerOn } from '../../../slices/marketplace/timeline/utils/catch-up-wait';

export interface CatchUpBannerProps {
    catchUp: Timeline | null;
    isReviewingTheTeaserAgain: boolean;
    onReviewTeaser: () => void;
    onOpenTheCatchUp: (catchUpTimelineId: number) => void;
}

// [#1298 / #1300 / #1299] Over the Seller's own timeline while it waits for the resume's catch-up: what the catch-up
// is, the teaser to review again, and the catch-up's steps waiting for the Seller, acted on in its own schedule.
export const CatchUpBanner = (props: CatchUpBannerProps) => {
    const waitingSteps = stepsWaitingForTheSellerOn(props.catchUp);
    return (
        <Alert color="info" className="catch-up-banner">
            The engagement has resumed. A catch-up replays it from the first step for the buyers who had left;
            this timeline and the buyers still in the deal stay where they stopped and continue once the
            catch-up reaches them.
            {props.isReviewingTheTeaserAgain && (
                <div className="catch-up-banner-action">
                    The catch-up has reached the teaser approval: review the teaser and confirm it again.
                    <Button color="link" className="review-teaser-btn p-0" onClick={props.onReviewTeaser}>
                        Review teaser
                    </Button>
                </div>
            )}
            {props.catchUp?.timelineId && (
                <div className="catch-up-banner-action">
                    {waitingSteps.length > 0
                        ? `Waiting for you on the catch-up: ${waitingSteps.map((step) => step.name).join(', ')}.`
                        : 'Nothing on the catch-up is waiting for you now.'}
                    <Button
                        color="link"
                        className="open-catch-up-btn p-0"
                        onClick={() => props.onOpenTheCatchUp(props.catchUp.timelineId)}>
                        Open the catch-up
                    </Button>
                </div>
            )}
        </Alert>
    );
};
